<template>
    <div>
        <div class="search flex">
            <span class="tit">医生列表</span>
            <div>
                <el-button @click="addDoctor" size="mini" class="addBtn">添加医生</el-button>
                <el-input placeholder="请输入关键信息" clearable v-model="page.key" @keyup.enter.native="getData()" class="addART">
                    <i class="el-icon-search" slot="suffix" @click="getData()"></i>
                </el-input>
            </div>
        </div>
        <div class="instrument mt-5">
            <el-table :data="applyList" class="record-table"
                      :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                      height="calc(100vh - 292px)"
                      style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
                      max-height="calc(100vh - 292px)">
                <el-table-column fixed prop="name" align="center" label="姓名" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gender" align="center" label="性别" width="70">
                    <span slot-scope="scope">{{scope.row.gender==0?'女': scope.row.gender==1 ?'男' : '-'}}</span>
                </el-table-column>
                <el-table-column prop="mobile" align="center" label="手机号" width="120"></el-table-column>
                <el-table-column prop="applyDate" align="center" label="申请时间" width="180"></el-table-column>
                <el-table-column prop="signature" align="left" label="签名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" align="left" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="handleStatus" label="处理状态" width="100">
                    <span slot-scope="scope" :class="['common',scope.row.handleStatus==0?'pink':'green']" @click="changeStatus(scope.row)">{{scope.row.handleStatus==0?'未处理':'已处理'}}</span>
                </el-table-column>
                <el-table-column align="center" label="附件" width="180">
                    <span class="el-icon-paperclip attachment" slot-scope="scope" @click="openAttachmentList(scope.row.id)">附件</span>
                </el-table-column>
            </el-table>
            <el-pagination class="pagination"
                           background
                           @current-change="handlePageChange"
                           :current-page="page.current"
                           :page-size="page.size"
                           prev-text="Prev"
                           next-text="Next"
                           layout=" prev, pager, next,total"
                           :total="page.total">
            </el-pagination>
        </div>
        <doctorAddDialog ref="adminDoctorAddDialog"></doctorAddDialog>
        <el-dialog :visible.sync="dialogVisible.statusDialog">
            <!-- TODO 变更为 状态 + 备注 形式 -->
            
        </el-dialog>
        
        <el-dialog :visible.sync="dialogVisible.attachmentDialog"
                   title="附件列表"
                   top="0"
                   :close-on-click-modal="false"
                   :show-close="true">
            <div class="attachment-list">
                <p v-for="(file,index) in attachments" :key="file.id">
                    <span>{{index+1}}.</span>{{file.fileName}}
                    <span class="file-download" @click="downloadFile(file.fileId)">下载</span>
                </p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import base from '@/api/common';
import doctorAddDialog from "./components/doctorAddDialog";
export default {
    name: "apply_list",
    data(){
        return {
            applyList: [],
            page:{
                key: '',
                current: 1,
                size: 10,
                rows: 12
            },
            dialogVisible:{
                statusDialog: false,
                attachmentDialog: false,
            },
            attachments:[]
        }
    },
    components:{
        doctorAddDialog
    },
    mounted() {
        this.getData();
    },
    methods:{
        addDoctor(){
            this.$refs.adminDoctorAddDialog.dialogVisible = true;
        },
        getData(){
            this.$ajax.get(base.basePath + 'auth/register-apply/admin/page',{data: {
                    page: this.page.current,
                    size: this.page.size,
                    key: this.page.key,
                }}).then(res=>{
                if(res.data.status === 'success'){
                    this.applyList = res.data.rows;
                    this.page.current = res.data.current;
                    this.page.total = res.data.total;
                    this.page.size = res.data.size;
                }else{
                    this.$message.error('数据加载失败！');
                }
            }).catch(err=>{
                this.$message.error('数据加载失败！');
            });
        },
        handlePageChange(){
            /*
            * TODO
            * 1. 分页信息处理
            * 2. 附件下载
            * 3. 附件详情
            * 4. 备注处理
            *
            * */
        },
        changeStatus(item){
            if(item && item.id){
                this.$messageBox.confirm('是否要变更为已处理?','提示',{type: "warning"}).then(()=>{
                    this.$ajax.post(base.basePath + 'auth/register-apply/admin/update/status/'+item.id).then(res=>{
                        if(res.data.status === 'success'){
                            item.handleStatus = 1;
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    }).catch(err=>{
                        console.error(err);
                        this.$message.error('操作失败');
                    })
                });
            }
        },
        openAttachmentList(id){
            this.attachments = []; //清空
            this.dialogVisible.attachmentDialog = true;
            this.$ajax.get(base.basePath + 'auth/register-apply/admin/attachment/list/'+id).then(res=>{
                if(res.data.status === 'success'){
                    this.attachments = res.data.list;
                }else{
                    this.$message.error('文件加载失败');
                }
            }).catch(err=>{
                console.error(err);
                this.$message.error('文件加载失败');
            })
        },
        downloadFile(id){
            //console.log('文件ID: ' + id);
            //let backPath = 'http://psychology.wbr.com/psy/';
            this.$ajax.get(base.basePath + 'auth/register-apply/admin/attachment-download/cv/' + id,{responseType: 'blob'}).then(res=>{
                if (!res) {
                    this.$message.error("文件下载失败");
                    return false;
                }
                const blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
                const downloadElement = document.createElement('a');
                const href = window.URL.createObjectURL(blob);
                let contentDisposition = res.headers['content-disposition'];  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
                let patten = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
                let result = patten.exec(contentDisposition);
                let filename = decodeURI(result[1]);
                downloadElement.style.display = 'none';
                downloadElement.href = href;
                downloadElement.download = filename ; //下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
                window.URL.revokeObjectURL(href); //释放掉blob对象
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/admin.scss';
span.common{
    cursor: pointer;
}
span.attachment{color: #567CFF;cursor: pointer}
.attachment-list{
    min-height: 150px;
    p{
        line-height: 30px;
        span.file-download{
            margin: 0;
            color: #567CFF;
            cursor: pointer;
        }
        span{
            margin-right: 10px;
        }
    }
}
</style>